import { copy } from '@/helpers/object';
import BookmarkedAttrs from '@/interface/BookmarkedAttrs';

const state = () => ({
  isLoading: false,

  list: [],
});

const mutations = {
  setLoading(s, newValue) {
    s.isLoading = newValue;
  },
  setList(s, newValue) {
    s.list = newValue;
  },
  removeBookmarkedItem(s, item) {
    s.list = s.list.filter(({ id }) => id !== item.id);
  },
};

const actions = {
  fetch({ commit }) {
    commit('setLoading', true);
    commit('setList', []);

    const url = this.getters.getApiLink('headhunter.getAllMarked');

    return this.$api
      .get(url)
      .then(({ data }) => {
        if (data?.status !== 'OK') {
          throw new Error('Request status is not OK');
        }

        const list = (data?.payload?.content?.resultList || []);
        commit('setList', list);

        return copy(list);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  saveBookmarked(_, attrs: BookmarkedAttrs) {
    const { id, value } = attrs;
    const urlKey = value ? 'mark' : 'unmark';
    const apiMethod = value ? 'post' : 'delete';

    return this.$api[apiMethod](this.getters.getApiLink(`headhunter.${urlKey}`, {
      companyUniqueId: id,
    }))
      .then(({ data }) => {
        if (data.status !== 'OK') {
          throw new Error('Something goes wrong');
        }

        return data;
      });
  },
  removeBookmarkedItem({ commit }, item) {
    commit('removeBookmarkedItem', item);
  },
};

const getters = {
  loading: (s) => s.isLoading,
  list: (s) => s.list,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
